import moment from 'moment';
import { SiteModuleEnum } from "../../../core/enum/site-module";
import { ScheduleEventAssignedStatus, IcdOfficeService } from "../../../core/services/data-services";
import { ScheduleEventDetailModal } from '../shared/schedule-event-detail.component';
import templateUrl from './dashboard-pending-events-review-container.component.html'
import { IQService, IOnInit } from 'angular';

import { IcdOfficeListResponse, ScheduleEventListResponse } from "@herbjoy/apex-api-models"

export const DashboardPendingEventsReviewContainerComponent = {
    templateUrl,
    require: {
        dashboardContext: "^?apexDashboardContent"
    },
    controller: class OwnerPendingEventsReviewContainerComponent implements IOnInit {
        dashboardContext: any;
        pageNumber = 1;
        pageSize = 10;
        //TODO: Add static types.
        icdOffices: { text: string, value: number }[];
        icdOffice: { text: string, value: number };
        scheduleEvents: ScheduleEventListResponse[];
        pagedScheduleEvents: ScheduleEventListResponse[];
        constructor(private $q: IQService, private $uibModal, private eventHostService,
            private icdOfficeService: IcdOfficeService,
            private scheduleEventService, private utilityService) {
            'ngInject';
        }

        $onInit() {
            const icdOfficesLoaded = this.icdOfficeService.retrieveIcdOffices({
                moduleID: SiteModuleEnum.EventsScheduling
            }).then((icdOffices: IcdOfficeListResponse[]) => this.icdOffices = icdOffices.map(office => ({
                value: office.Id,
                text: `${office.OwnerName} - ${office.IcdCorporationName} (${office.OfficeName})`
            })));

            icdOfficesLoaded.then(() => {
                this.icdOffice = this.icdOffices.length === 1 ? this.icdOffices[0] : null;

                if (!this.icdOffice && this.dashboardContext) {
                    // Auto-activate dashboard by default.
                    this.dashboardContext.activateDashboard({
                        visible: true,
                        count: 0
                    });
                }
                return this.loadScheduleEvents();
            });

        }

        onChangeIcdOffice() {

            this.pageNumber = 1;
            this.loadScheduleEvents();
        }

        onRespond({ scheduleEvent, response }) {
            const responded = this.scheduleEventService.patchScheduleEvent(scheduleEvent.ScheduleEventID, {
                ChangeIcdOfficeAcceptance: {
                    AssignedStatus: response,
                    IcdOfficeID: this.icdOffice.value
                }
            });

            responded.then(() => {
                scheduleEvent.responded = response !== ScheduleEventAssignedStatus.Pending;
                scheduleEvent.AssignedStatus = response;
            });

            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(responded, "Response failed")
            );
        }

        onChangePage() {
            this.paginateScheduleEvents();
        }

        onViewScheduleEventDetails({ scheduleEvent }) {
            const detail = this.scheduleEventService.retrieveScheduleEvent(scheduleEvent.ScheduleEventID)
                .then(detail => {
                    // Hydrate with schedule event details
                    return this.hydrateScheduleEvent(detail);
                });

            this.utilityService.showLoadingUntilResolved(detail);

            this.$uibModal.open({
                ...ScheduleEventDetailModal,
                resolve: {
                    scheduleEvent: detail
                }
            });
        }

        paginateScheduleEvents() {
            if (!this.scheduleEvents) {
                this.pagedScheduleEvents = [];
            }

            this.pagedScheduleEvents = this.scheduleEvents.slice((this.pageNumber - 1) * this.pageSize,
                this.pageNumber * this.pageSize);
        }

        loadScheduleEvents() {
            if (!this.icdOffice) {
                this.scheduleEvents = [];
                return this.$q.resolve(this.scheduleEvents);
            }
            this.scheduleEventService.retrieveOfficeAssignedScheduleEvents(this.icdOffice.value, {
                assignedStatusID: ScheduleEventAssignedStatus.Pending,
                // Limit to schedules that haven't ended yet.
                startDate: moment().format("YYYY-MM-DD")
            })
                .then(scheduleEvents => this.scheduleEvents = scheduleEvents)
                .then(() => {
                    if (this.dashboardContext) {
                        this.dashboardContext.activateDashboard({
                            visible: true,
                            count: this.scheduleEvents.length
                        });
                    }
                })
                .then(() => this.paginateScheduleEvents());
        }

        hydrateScheduleEvent(detail) {
            const eventHostLoaded = this.eventHostService.retrieveEventHost(detail.EventHostID)
                .then(eventHost => detail.EventHost = eventHost);

            return this.$q.all([eventHostLoaded])
                .then(() => detail);
        }
    }
};
